import { interFontFamily, ttNormsFontFamily } from "../../../fonts/fonts";

type InterSize = 12 | 14 | 16 | 20;
type InterWeight = 400 | 500 | 600 | 700;
type TTNormsProSize = 10 | 14 | 20 | 24 | 28 | 38;
type TTNormsProWeight = 400 | 700;

type UrsaTypeRampVariant =
    | `Inter--${InterSize}px--${InterWeight}w`
    | `Inter--${10}px--${500}w`
    | `TT-Norms-Pro--${TTNormsProSize}px--${TTNormsProWeight}w`
    | `TT-Norms-Pro--${14}px--${500}w`;

interface TypeRampProperties {
    fontFamily: typeof interFontFamily | typeof ttNormsFontFamily;
    fontSize: string;
    fontWeight: number;
    lineHeight: string;
}

export const ursaTypeRampDefinitions: { [key in UrsaTypeRampVariant]: TypeRampProperties } = {
    "Inter--10px--500w": {
        fontFamily: interFontFamily,
        fontSize: "10px",
        fontWeight: 500,
        lineHeight: "12px",
    },
    "Inter--12px--400w": {
        fontFamily: interFontFamily,
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "16px",
    },
    "Inter--12px--500w": {
        fontFamily: interFontFamily,
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
    },
    "Inter--12px--600w": {
        fontFamily: interFontFamily,
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: "16px",
    },
    "Inter--12px--700w": {
        fontFamily: interFontFamily,
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
    },
    "Inter--14px--400w": {
        fontFamily: interFontFamily,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "18px",
    },
    "Inter--14px--500w": {
        fontFamily: interFontFamily,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "18px",
    },
    "Inter--14px--600w": {
        fontFamily: interFontFamily,
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "18px",
    },
    "Inter--14px--700w": {
        fontFamily: interFontFamily,
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "18px",
    },
    "Inter--16px--400w": {
        fontFamily: interFontFamily,
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "20px",
    },
    "Inter--16px--500w": {
        fontFamily: interFontFamily,
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "20px",
    },
    "Inter--16px--600w": {
        fontFamily: interFontFamily,
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "20px",
    },
    "Inter--16px--700w": {
        fontFamily: interFontFamily,
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: "20px",
    },
    "Inter--20px--400w": {
        fontFamily: interFontFamily,
        fontSize: "20px",
        fontWeight: 400,
        lineHeight: "24px",
    },
    "Inter--20px--500w": {
        fontFamily: interFontFamily,
        fontSize: "20px",
        fontWeight: 500,
        lineHeight: "24px",
    },
    "Inter--20px--600w": {
        fontFamily: interFontFamily,
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "24px",
    },
    "Inter--20px--700w": {
        fontFamily: interFontFamily,
        fontSize: "20px",
        fontWeight: 700,
        lineHeight: "24px",
    },
    "TT-Norms-Pro--10px--400w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "10px",
        fontWeight: 400,
        lineHeight: "12px",
    },
    "TT-Norms-Pro--10px--700w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "10px",
        fontWeight: 700,
        lineHeight: "12px",
    },
    "TT-Norms-Pro--14px--400w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "18px",
    },
    "TT-Norms-Pro--14px--500w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "18px",
    },
    "TT-Norms-Pro--14px--700w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "18px",
    },
    "TT-Norms-Pro--20px--400w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "20px",
        fontWeight: 400,
        lineHeight: "24px",
    },
    "TT-Norms-Pro--20px--700w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "20px",
        fontWeight: 700,
        lineHeight: "24px",
    },
    "TT-Norms-Pro--24px--400w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "24px",
        fontWeight: 400,
        lineHeight: "30px",
    },
    "TT-Norms-Pro--24px--700w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "24px",
        fontWeight: 700,
        lineHeight: "30px",
    },
    "TT-Norms-Pro--28px--400w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "28px",
        fontWeight: 400,
        lineHeight: "34px",
    },
    "TT-Norms-Pro--28px--700w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "28px",
        fontWeight: 700,
        lineHeight: "34px",
    },
    "TT-Norms-Pro--38px--400w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "38px",
        fontWeight: 400,
        lineHeight: "46px",
    },
    "TT-Norms-Pro--38px--700w": {
        fontFamily: ttNormsFontFamily,
        fontSize: "38px",
        fontWeight: 700,
        lineHeight: "46px",
    },
};
